import { api } from 'src/services';
import getChatToken from './getChatToken';
import createChatRoom from './createChatRoom';

export const chatApis = api.injectEndpoints({
  endpoints: (build) => ({
    getChatToken: getChatToken(build),
    createChatRoom: createChatRoom(build),
  }),
  overrideExisting: true,
});

export const { useGetChatTokenMutation, useCreateChatRoomMutation } = chatApis;
